import { useState } from 'react';
import { useDropzone } from 'react-dropzone'
import { useSelector, useDispatch } from 'react-redux';

import { updateUserProfile } from '../../lib/api';
import userPlaceholder from '../../../src/assets/images/userPlaceholder.jpg'
import Input from '../UI/Input';
import CropImageModal from '../Modals/CropImage';
// import { updateUserImage, updateUserName } from '../../redux/userSlice';
import { updateUserImage, updateUserName } from '../../redux/userSlice';

const PersonalInfo = (props) => {
  const dispatch = useDispatch();

  const { currentUser } = useSelector((state) => state.user);

  const { picture, firstName, lastName } = props.userData;

  const [cropImage, setCropImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(false);
  const [isWebCamEnabled, setIsWebCamEnabled] = useState(false)
  const [isCropImageModal, setIsCropImageModal] = useState(false)
  const [isFirstNameValid, setIsFirstNameValid] = useState(true)
  const [firstNameError, setFirstNameError] = useState()
  const [lastNameError, setLastNameError] = useState()
  const [isLastNameValid, setIsLastNameValid] = useState(true)
  const [isFileLoading, setIsFileLoading] = useState(false);
  const [exceededImageSizeError, setExceededImageSizeError] = useState(false)

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      setIsFileLoading(false);
      setExceededImageSizeError(true)
    } else {
      setIsFileLoading(true);
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const imageUrl = URL.createObjectURL(acceptedFiles[0]);
          setCropImage(imageUrl);
          setIsCropImageModal(true)
          props.setUnsavedChanges(true)
        } catch (error) {
          console.error('Error creating object URL:', error);
        }
      }
      reader.readAsDataURL(acceptedFiles[0])
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      "image/jpeg": [],
      "image/png": [],
    },
    maxSize: 1000000,
    disabled: isFileLoading ? true : false
  });

  const formValidation = (name, e, value) => {
    if (name === "firstName") {
      if (!value) { setIsFirstNameValid(false); setFirstNameError("Please enter first name") }
      else if (value[0] === ' ') { setIsFirstNameValid(false); setFirstNameError("First name cannot start with space") }
      else if (value.length > 15) { setIsFirstNameValid(false); setFirstNameError("Allowed max limit is 15 characters") }
      else if (value.match(/\d/)) { setIsFirstNameValid(false); setFirstNameError("First name cannot contain numeric values") }
      else if (value.match(/[\]\\!@=+~`_/[;'#$%^&*(),.?":{}|<>]/)) { setIsFirstNameValid(false); setFirstNameError("First name cannot contain special characters") }
      else { setFirstNameError(''); setIsFirstNameValid(true); }
    }

    if (name === "lastName") {
      if (!value) { setIsLastNameValid(false); setLastNameError("Please enter last name") }
      else if (value[0] === ' ') { setIsLastNameValid(false); setLastNameError("Last name cannot start with space") }
      else if (value.length > 20) { setIsLastNameValid(false); setLastNameError("Allowed max limit is 20 characters") }
      else if (value.match(/\d/)) { setIsLastNameValid(false); setLastNameError("Last name cannot contain numeric values") }
      else if (value.match(/[\]\\!@=+~`_/[;'#$%^&*(),.?":{}|<>]/)) { setIsLastNameValid(false); setLastNameError("Last name cannot contain special characters") }
      else { setLastNameError(''); setIsLastNameValid(true); }
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    formValidation(name, e, value)
    props.setUnsavedChanges(true)
    props.setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleProfileUpdate = (event) => {
    event.preventDefault()
    props.setIsLoading(true)

    const updateData = {
      field_picture: { value: picture },
      field_first_name: { value: firstName },
      field_last_name: { value: lastName }
    }

    updateUserProfile(currentUser.access_token, currentUser.current_user.uid, updateData)
      .then(async (res) => {
        setCropImage()
        setIsWebCamEnabled(false)
        setImagePreview(false)
        dispatch(updateUserImage(picture !== undefined ? picture : null))
        dispatch(updateUserName(firstName + ' ' + lastName))
        props.getUserProfileDetails()
        setIsFileLoading(false)
        props.setIsLoading(false)
        props.setUnsavedChanges(false)
        props.setIsEditProfileInfo(false)
        props.setIsProfileUpdated(true)
      })
  }

  const handleCancel = () => {
    setCropImage()
    setIsFileLoading(false)
    setIsWebCamEnabled(false)
    setIsCropImageModal(false)
    setImagePreview(false)
    props.handleCancel()
  }

  const firstNameClasses = !isFirstNameValid
    ? "nameSection  flex flex-col gap-1 invalid mb-2"
    : "nameSection  flex flex-col gap-1";

  const lastNameClasses = !isLastNameValid
    ? "nameSection  flex flex-col gap-1 invalid mb-2"
    : "nameSection  flex flex-col gap-1 mt-3";

  return (
    <div ref={props.editModeRef} className="profileInfo basis-full sm:basis-4/12 md:basis-3/12 lg:basis-2/12">
      <div className={!props.isEditProfileInfo ? "profilePictureHolder  size-24 sm:size-[142px] rounded-full relative transition-all ease-in-out duration-700 mx-auto" : "profilePictureHolder  size-28 sm:size-[142px] rounded-full relative transition-all ease-in-out duration-700 mx-auto shadow-activeShadow mb-4 flex justify-center flex-col gap-2"}>
        {!props.isEditProfileInfo ?
          <img src={(picture !== null) ? picture : userPlaceholder} className="h-full w-full rounded-full mx-auto" alt="profilePic" title="User" />
          :
          !imagePreview ?
            <>
              <div onClick={() => { setIsWebCamEnabled(true); setIsCropImageModal(true) }} className='uploadIconHolder flex justify-center cursor-pointer'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 6V6.75C7.25076 6.75 7.48494 6.62467 7.62404 6.41603L7 6ZM8.40627 3.8906L7.78223 3.47457L7.78223 3.47457L8.40627 3.8906ZM15.5937 3.8906L16.2178 3.47457L15.5937 3.8906ZM17 6L16.376 6.41603C16.5151 6.62467 16.7492 6.75 17 6.75V6ZM14.25 13.5C14.25 14.7426 13.2426 15.75 12 15.75V17.25C14.0711 17.25 15.75 15.5711 15.75 13.5H14.25ZM12 15.75C10.7574 15.75 9.75 14.7426 9.75 13.5H8.25C8.25 15.5711 9.92893 17.25 12 17.25V15.75ZM9.75 13.5C9.75 12.2574 10.7574 11.25 12 11.25V9.75C9.92893 9.75 8.25 11.4289 8.25 13.5H9.75ZM12 11.25C13.2426 11.25 14.25 12.2574 14.25 13.5H15.75C15.75 11.4289 14.0711 9.75 12 9.75V11.25ZM7.62404 6.41603L9.0303 4.30662L7.78223 3.47457L6.37596 5.58397L7.62404 6.41603ZM10.0704 3.75H13.9296V2.25H10.0704V3.75ZM14.9697 4.30662L16.376 6.41603L17.624 5.58397L16.2178 3.47457L14.9697 4.30662ZM13.9296 3.75C14.3476 3.75 14.7379 3.95888 14.9697 4.30662L16.2178 3.47457C15.7077 2.70953 14.8491 2.25 13.9296 2.25V3.75ZM9.0303 4.30662C9.26214 3.95888 9.65243 3.75 10.0704 3.75V2.25C9.1509 2.25 8.29226 2.70953 7.78223 3.47457L9.0303 4.30662ZM21.25 10V17H22.75V10H21.25ZM18 20.25H6V21.75H18V20.25ZM2.75 17V10H1.25V17H2.75ZM6 20.25C4.20507 20.25 2.75 18.7949 2.75 17H1.25C1.25 19.6234 3.37665 21.75 6 21.75V20.25ZM21.25 17C21.25 18.7949 19.7949 20.25 18 20.25V21.75C20.6234 21.75 22.75 19.6234 22.75 17H21.25ZM18 6.75C19.7949 6.75 21.25 8.20507 21.25 10H22.75C22.75 7.37665 20.6234 5.25 18 5.25V6.75ZM6 5.25C3.37665 5.25 1.25 7.37665 1.25 10H2.75C2.75 8.20507 4.20507 6.75 6 6.75V5.25ZM6 6.75H7V5.25H6V6.75ZM18 5.25H17V6.75H18V5.25Z" fill="#364461" />
                  <circle cx="12" cy="6" r="1" fill="#364461" />
                </svg>
              </div>
              <div {...getRootProps({ className: "dropzone" })}>
                <input {...getInputProps()} />
                <p className="text-xs leading-4 text-center mx-2">
                  Drag and drop files here or
                  <span className='browseImageLink text-[#0057B8] font-medium decoration-1 underline cursor-pointer'>
                    {" "}
                    Browse
                  </span>
                </p>
              </div>
              {isCropImageModal && <CropImageModal
                editModeRef={props.editModeRef}
                setIsFileLoading={setIsFileLoading}
                cropImage={cropImage}
                setCropImage={setCropImage}
                isWebCamEnabled={isWebCamEnabled}
                setIsWebCamEnabled={setIsWebCamEnabled}
                onClose={setIsCropImageModal}
                initialValue={props.initialValue}
                setUserData={props.setUserData}
                setImagePreview={setImagePreview}
              />}
            </> : <img src={picture} className="h-full w-full rounded-full mx-auto" alt="profilePic" title="User" />}
      </div>
      {exceededImageSizeError && <p className="error-text text-center">Please choose an image lesser than 1Mb to upload.</p>}
      {!props.isEditProfileInfo ?
        <p className="profileName mt-4 text-[#373A3C] font-medium leading-normal text-xl sm:text-2xl text-center">{firstName + ' ' + lastName}</p> : <>
          <div className={firstNameClasses}>
            <Input
              labelClass="firstNameLabel text-[#333] text-sm font-normal leading-5"
              input={{
                id: "firstName",
                name: "firstName",
                type: "text",
                value: firstName,
                placeholder: "Enter first name",
                onChange: (e) => handleChange(e),
                className:
                  "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  !text-[#333]",
              }}
            />
            {!isFirstNameValid && (
              <p className="error-text">
                {firstNameError}
              </p>
            )}
          </div>
          <div className={lastNameClasses}>
            <Input
              labelClass="firstNameLabel text-[#333] text-sm font-normal leading-5"
              input={{
                id: "lastName",
                name: "lastName",
                type: "text",
                value: lastName,
                placeholder: "Enter last name",
                onChange: handleChange,
                className:
                  "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  !text-[#333]",
              }}
            />
            {!isLastNameValid && (
              <p className="error-text">
                {lastNameError}
              </p>
            )}
          </div></>}
      <div className="editOption flex gap-[6px] items-center cursor-pointer justify-center mt-5 sm:mt-9 border-t border-t-[#ddd] pt-4  mx-auto">
        {!props.isEditProfileInfo ? <div className="flex items-center gap-1" onClick={() => props.handleEdit(1)}><span className="editIcon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.698289">
              <path fillRule="evenodd" clipRule="evenodd" d="M10.7736 1.62902C11.6123 0.790326 12.972 0.790326 13.8107 1.62902L14.3707 2.18902C15.2081 3.02827 15.2081 4.38689 14.3707 5.22614L5.85682 13.7404C5.79847 13.7988 5.72614 13.8409 5.64673 13.8629L1.60463 14.9827C1.43891 15.0286 1.26144 14.9818 1.1397 14.8602C1.01816 14.7385 0.971369 14.561 1.01741 14.3953L2.13704 10.3532C2.15904 10.2738 2.20117 10.2014 2.25952 10.1431L10.7736 1.62902ZM10.2675 3.485L3.29936 10.4533L5.54644 12.7006L12.5147 5.73227L10.2675 3.485ZM2.85046 11.3541L4.64585 13.1496L2.16239 13.8377L2.85046 11.3541ZM13.1898 5.05743L13.6959 4.55131C14.161 4.08508 14.161 3.33027 13.6959 2.86385L13.1357 2.30385C12.6698 1.838 11.9145 1.838 11.4486 2.30385L10.9423 2.80998L13.1898 5.05743Z" fill="#717375" />
              <path d="M13.8107 1.62902L13.9875 1.45224V1.45224L13.8107 1.62902ZM10.7736 1.62902L10.5968 1.45224V1.45224L10.7736 1.62902ZM14.3707 2.18902L14.5477 2.01244L14.5475 2.01224L14.3707 2.18902ZM14.3707 5.22614L14.5475 5.40291L14.5477 5.40272L14.3707 5.22614ZM5.85682 13.7404L6.0336 13.9172L6.0336 13.9172L5.85682 13.7404ZM5.64673 13.8629L5.57999 13.622L5.57999 13.622L5.64673 13.8629ZM1.60463 14.9827L1.6713 15.2236L1.67138 15.2236L1.60463 14.9827ZM1.1397 14.8602L0.962793 15.0369L0.963063 15.0371L1.1397 14.8602ZM1.01741 14.3953L1.25829 14.4622L1.25834 14.462L1.01741 14.3953ZM2.13704 10.3532L1.89611 10.2865H1.89611L2.13704 10.3532ZM2.25952 10.1431L2.43629 10.3199H2.43629L2.25952 10.1431ZM3.29936 10.4533L3.12258 10.2765L2.94581 10.4533L3.12257 10.6301L3.29936 10.4533ZM10.2675 3.485L10.4442 3.30822L10.2675 3.13144L10.0907 3.30822L10.2675 3.485ZM5.54644 12.7006L5.36965 12.8773L5.54643 13.0541L5.72321 12.8773L5.54644 12.7006ZM12.5147 5.73227L12.6915 5.90904L12.8683 5.73227L12.6915 5.55549L12.5147 5.73227ZM4.64585 13.1496L4.7126 13.3906L5.12581 13.2761L4.82264 12.9729L4.64585 13.1496ZM2.85046 11.3541L3.02725 11.1773L2.72403 10.8741L2.60954 11.2873L2.85046 11.3541ZM2.16239 13.8377L1.92147 13.771L1.80357 14.1966L2.22914 14.0786L2.16239 13.8377ZM13.6959 4.55131L13.8727 4.72808L13.8729 4.72787L13.6959 4.55131ZM13.1898 5.05743L13.013 5.23421L13.1898 5.41099L13.3665 5.23421L13.1898 5.05743ZM13.6959 2.86385L13.8729 2.68732L13.8726 2.68705L13.6959 2.86385ZM13.1357 2.30385L12.9589 2.48063L12.9589 2.48066L13.1357 2.30385ZM11.4486 2.30385L11.6254 2.48066L11.6254 2.48063L11.4486 2.30385ZM10.9423 2.80998L10.7656 2.63317L10.5887 2.80995L10.7655 2.98675L10.9423 2.80998ZM13.9875 1.45224C13.0512 0.515919 11.5331 0.515919 10.5968 1.45224L10.9504 1.8058C11.6914 1.06473 12.8929 1.06473 13.6339 1.8058L13.9875 1.45224ZM14.5475 2.01224L13.9875 1.45224L13.6339 1.8058L14.1939 2.3658L14.5475 2.01224ZM14.5477 5.40272C15.4824 4.46588 15.4824 2.94928 14.5477 2.01244L14.1937 2.3656C14.9338 3.10727 14.9338 4.30789 14.1937 5.04956L14.5477 5.40272ZM6.0336 13.9172L14.5475 5.40291L14.1939 5.04937L5.68004 13.5636L6.0336 13.9172ZM5.71347 14.1038C5.83445 14.0703 5.9447 14.0061 6.0336 13.9172L5.68005 13.5636C5.65225 13.5914 5.61784 13.6115 5.57999 13.622L5.71347 14.1038ZM1.67138 15.2236L5.71348 14.1038L5.57999 13.622L1.53789 14.7418L1.67138 15.2236ZM0.963063 15.0371C1.14838 15.2222 1.41875 15.2935 1.6713 15.2236L1.53796 14.7417C1.45906 14.7636 1.37449 14.7414 1.31635 14.6833L0.963063 15.0371ZM0.776539 14.3284C0.706325 14.5811 0.777758 14.8515 0.962793 15.0369L1.31662 14.6836C1.25856 14.6254 1.23641 14.541 1.25829 14.4622L0.776539 14.3284ZM1.89611 10.2865L0.776486 14.3286L1.25834 14.462L2.37797 10.4199L1.89611 10.2865ZM2.08274 9.96632C1.99384 10.0552 1.92962 10.1655 1.89611 10.2865L2.37797 10.4199C2.38845 10.3821 2.4085 10.3477 2.43629 10.3199L2.08274 9.96632ZM10.5968 1.45224L2.08274 9.96632L2.43629 10.3199L10.9504 1.8058L10.5968 1.45224ZM3.47614 10.6301L10.4443 3.66177L10.0907 3.30822L3.12258 10.2765L3.47614 10.6301ZM5.72322 12.5238L3.47614 10.2765L3.12257 10.6301L5.36965 12.8773L5.72322 12.5238ZM12.338 5.55549L5.36966 12.5238L5.72321 12.8773L12.6915 5.90904L12.338 5.55549ZM10.0907 3.66177L12.338 5.90904L12.6915 5.55549L10.4442 3.30822L10.0907 3.66177ZM4.82264 12.9729L3.02725 11.1773L2.67368 11.5308L4.46907 13.3264L4.82264 12.9729ZM2.22914 14.0786L4.7126 13.3906L4.5791 12.9087L2.09564 13.5968L2.22914 14.0786ZM2.60954 11.2873L1.92147 13.771L2.40332 13.9045L3.09139 11.4208L2.60954 11.2873ZM13.5191 4.37453L13.013 4.88066L13.3665 5.23421L13.8727 4.72808L13.5191 4.37453ZM13.5189 3.04038C13.8867 3.40924 13.8866 4.00611 13.5189 4.37474L13.8729 4.72787C14.4354 4.16404 14.4353 3.2513 13.8729 2.68732L13.5189 3.04038ZM12.9589 2.48066L13.5191 3.04066L13.8726 2.68705L13.3124 2.12705L12.9589 2.48066ZM11.6254 2.48063C11.9936 2.1124 12.5907 2.1124 12.9589 2.48063L13.3125 2.12708C12.749 1.56359 11.8353 1.56359 11.2718 2.12708L11.6254 2.48063ZM11.119 2.98679L11.6254 2.48066L11.2719 2.12704L10.7656 2.63317L11.119 2.98679ZM13.3665 4.88066L11.1191 2.6332L10.7655 2.98675L13.013 5.23421L13.3665 4.88066Z" fill="#717375" />
            </g>
          </svg>
        </span>
          <span className="editlabel text-sm sm:text-base font-bold leading-normal text-primaryBlue">Edit</span></div> : <>
          <span className="editlabel text-sm sm:text-base font-bold leading-normal text-primaryBlue" onClick={(e) => handleProfileUpdate(e)}>Save |</span>
          <span className="editlabel text-sm sm:text-base font-bold leading-normal text-primaryBlue" onClick={handleCancel}>Cancel</span></>
        }
      </div>
    </div>
  );
};

export default PersonalInfo;